<template>
  <div>
    <b-navbar v-if="desktop || largeDesktop" toggleable="md" type="light" class="org py-4 px-4">
      <div class="sidebar-header">
        <h2>{{ $route.meta.name }}</h2>
      </div>
      <b-collapse is-nav id="nav_collapse" style="display: contents;">
        <b-navbar-nav class="ml-auto user">
          <b-nav-item-dropdown right>
            <template slot="button-content">
              <i class="fas fa-user-circle mr-2"></i>
              <span v-if="userInfo">{{ userInfo.user_profile.full_name }}</span>
            </template>
            <b-dropdown-item @click="logout">Выход</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <nav v-if="mobile || tablet" class="d-flex align-items-center justify-content-between py-2 px-2">
      <div class="navbar-header d-flex align-items-center justify-content-between">
        <button type="button" v-b-toggle.sidebar-mobile class="btn burger">
          <i class="fas fa-bars"></i>
        </button>
        <span class="section-title">{{ $route.meta.name }}</span>
      </div>
      <b-dropdown size="md" variant="link" dropleft toggle-class="text-decoration-none" no-caret>
        <template v-slot:button-content>
          <i class="fas fa-user-circle"></i>
        </template>
        <b-dropdown-item v-if="userInfo">{{ userInfo.user_profile.full_name }}</b-dropdown-item>
        <b-dropdown-divider v-if="userInfo"></b-dropdown-divider>
        <b-dropdown-item @click="logout">Выход</b-dropdown-item>
      </b-dropdown>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import menu from './menu.js'

export default {
  name: 'main-header',
  data () {
    return {
      userMenu: menu.userMenu
    }
  },
  computed: {
    ...mapState(
      {
        userInfo: state => state.authorization.userInfo,
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop
      }
    )
  },
  methods: {
    logout () {
      this.logOut()
        .then(() => {
          this.$router.push('/login')
        })
    },
    ...mapActions({
      logOut: 'authorization/logout'
    }),
    ...mapMutations({
      showMenu: 'toggleMenu',
      setUserInfo: 'authorization/setUserInfo'
    })
  }
}
</script>

<style lang="scss" scoped>
  nav.navbar {
    margin-bottom: 0px;
  }

  .logo {
    margin: 0 16px;
  }

  .vertslash {
    display: block;
    margin: 0 15px 0 10px;
    position: relative;
  }

  .vertslash h2 {
    position: absolute;
    top: -16px;
  }

  .navbar.org {
    background: #ffffff;
    padding: 9px 13px;
  }

  .burger {
    background-color: #ffffff;
  }

  .btn.burger:focus {
    box-shadow: none;
  }

  .section-title {
    font-size: 14px;
    font-weight: 500;
  }

  .navbar.org {
    background: #ffffff;
    padding: 9px 13px;
    margin-bottom: 0;
    & .sidebar-header {
      display: flex;
      align-items: center;
      & h2 {
        font-family: "PT Root UI Bold", Tahoma, Geneva, Verdana, sans-serif;
        margin-bottom: 0;
        color: #37474F;
        font-size: 1.425rem;
        font-weight: 500;
        line-height: 28px;
      }
      .logo {
        margin: 0 10px;
        margin-right: 18px;
        /* width: 32px;
        height: 32px; */
        width: 24px;
        height: 24px;
      }
      .vertslash {
        display: block;
        margin: 0 15px 0 10px;
        position: relative;
        & h2 {
          position: absolute;
          top: -16px;
        }
      }
      .burger {
        background-color: #ffffff;
        &:focus {
          box-shadow: none;
        }
      }
      .section-title {
        font-size: 18px;
        font-weight: 500;
      }
    }
  }
  .navbar-header {
    & h2 {
      margin-bottom: 0;
      color: #37474F;
      font-size: 25px;
      font-weight: 500;
      line-height: 28px;
    }
  }
</style>
